import { Stack, Typography } from "@mui/material";
import { useRemoveClientMutation } from "../../../../api";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { ReuseModal } from "../../ReuseModal";

type Props = {
  id: string;
  onClose: () => void;
  onSuccessHandler: () => void;
};

export const RemoveClientModal = ({ id, onClose, onSuccessHandler }: Props) => {
  const [removeClient, { isLoading }] = useRemoveClientMutation();

  const discardHandler = () => {
    removeClient(id)
      .unwrap()
      .then(onSuccessHandler)
      .catch(() =>
        toast.error(
          <CustomToast
            type={"error"}
            text={`Something went wrong. Please try again`}
            title={"Removed failed"}
          />,
        ),
      );
  };
  return (
    <ReuseModal
      isOpen={true}
      onClose={onClose}
      title={"Delete Client User?"}
      submitBtnColor={"#CF3E00"}
      onSubmit={discardHandler}
      maxWidth={"430px"}
      isLoading={isLoading}
      isDisabledCancelBtn={isLoading}
      isDisabled={isLoading}
      submitBtnText={"Delete"}
    >
      <Stack gap="8px" paddingBottom={"16px"}>
        <Typography component="span" variant="body1" color="text.secondary">
          This action will permanently remove the client user and revoke their
          access to the platform.
        </Typography>
        <Typography component="span" variant="body1" color="text.secondary">
          This action cannot be undone.
        </Typography>
      </Stack>
    </ReuseModal>
  );
};
